import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';
import Icon from 'js/components/common/Icon';

const activeColor = lightGrey2Color;
const hoverColor = lightGrey2Color.darken();
const disabledColor = lightGrey2Color.brighten(0.5);

export default styled(Icon)`
  font-size: 1rem;
  color: ${({ disabled }) => (disabled ? disabledColor : activeColor)};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  align-self: center;
  position: relative;
  top: 1px;

  &:hover {
    color: ${({ disabled }) => (disabled ? disabledColor : hoverColor)};
  }
`;
